import React from 'react'
import { BodyText, Button, HeadingText } from '@paypalcorp/pp-react'

function InvitationRestricted({ closeSheet }) {
  return (
    <>
      <div
        style={{
          marginBottom: '10px',
          paddingLeft: '15px',
          paddingRight: '15px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <img
            src="https://www.paypalobjects.com/paypal-ui/icons/v5/svg/report-problem.svg"
            alt="report-problem"
            style={{ width: '100px' }}
          />
          <HeadingText
            size="sm"
            style={{ marginTop: '10px', textAlign: 'center' }}
          >
            We are unable to process your invitation
          </HeadingText>
          <BodyText style={{ marginTop: '20px', textAlign: 'center' }}>
            Federal regulations prohibit inviting developers from the following
            countries of concern: China, Macau, Hong Kong, Cuba, Iran, North
            Korea, Russia, and Venezuela.
          </BodyText>
          <Button
            onClick={() => closeSheet()}
            data-dxa="close_invitation_restricted,redirect,close_invitation_restricted"
            data-testid="closeInvitationRestricted"
            style={{ marginTop: '20px' }}
          >
            Close
          </Button>
        </div>
      </div>
    </>
  )
}

export default InvitationRestricted
